import React from 'react'
import useMediaQuery from '../../../shared/utils/useMediaQuery'

import img_stickers from '../../../assets/images/img-stickers.png'
import Button from '../../atoms/button/button'

import './stickersSection.scss'
import { navigate } from 'gatsby'
import { LOCALE, TROPICALIZED } from '../../../constants/activity-constants'
import Show from '../../../utils/show'
const StickersSection = () => {
  const isMobile = useMediaQuery()

  return (
    <div className="f-stickersSection-container">
      <div className="f-stickersSection-container__ancla" id="stickers" />
      <div className="f-stickersSection-wrapper">
        <figure className="f-stickersSection-container__left">
          <img src={img_stickers} alt="stickers para whatsapp Nosotras" />
          {isMobile && (
            <Button
              text="¡Los quiero!"
              onClick={() => {
                navigate('/stickers')
              }}
              metric={{
                event: 'Interacciones_Home_Navidad',
                category: 'Stickers',
              }}
            />
          )}
        </figure>
        <section className="f-stickersSection-container__right">
          {LOCALE !== 'es-BO' && (
            <span className="f-romboPuntosRedeem f-stickersSection-cover">
              <b className="f-romboPuntosRedeem__numero">10</b>
            </span>
          )}
          <h1>¡Pack de stickers para tu Whatsapp!</h1>
          <p>
            <Show valid={TROPICALIZED}>
              <b>
                Tus personajes favoritos de Nosotras ahora los podrás tener en
                tu Whatsapp. Canjeá 10 puntos,
              </b>{' '}
              descargá un pack de stickers y soprendé a tus contactos.
            </Show>
            <Show valid={TROPICALIZED === false}>
              <b>
                Tus personajes favoritos de Nosotras ahora los podrás tener en
                tu Whatsapp.{' '}
                {LOCALE !== 'es-BO' &&
                  (['es-PE', 'es-CL'].includes(LOCALE)
                    ? 'Canjea 10 puntos,'
                    : 'Redime 10 puntos,')}
              </b>{' '}
              descarga un pack de stickers y soprende a tus contactos.
            </Show>
          </p>

          {!isMobile && (
            <Button
              text="¡Los quiero!"
              onClick={() => {
                navigate('/stickers')
              }}
              metric={{
                event: 'Interacciones_Home_Navidad',
                category: 'Stickers',
              }}
            />
          )}
        </section>
      </div>
    </div>
  )
}

export default StickersSection
